export const OpportunityStatuses = {
    scheduled: 1,
    sold: 2,
    closed: 3,
    open: 4
};
